<template>
  <v-list-item
    selectable
    class="notification-item"
    :inactive="!notification.action"
    :ripple="false"
    @click="onAction(notification.action)"
  >
    <template #default>
      <v-list-item-content>
        <v-list-item-title v-text="notification.title" />

        <!-- eslint-disable-next-line vue/no-v-html -->
        <v-list-item-subtitle v-html="notification.content" />
      </v-list-item-content>

      <v-list-item-action
        v-if="!notification.persistent"
        class="align-self-stretch d-flex align-center justify-center my-0"
      >
        <v-list-item-action-text class="text--disabled text-caption mb-1">
          {{ notification.timestamp | relativeTime('mini') }} ago
        </v-list-item-action-text>

        <v-tooltip
          left color="grey800"
          content-class="py-1 text-caption"
          transition="slide-x-transition"
          open-delay="400"
        >
          <template #activator="{on}">
            <v-btn
              icon
              color="grey100"
              :ripple="false"
              v-on="on"
              @click="$emit('dismiss', notification.id)"
            >
              <fai icon="check" />
            </v-btn>
          </template>
          <span>Dismiss</span>
        </v-tooltip>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>

<script>
import NotifActionHandler from '@/utils/notification-action-handler'

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onAction(action) {
      if (!action) return
      NotifActionHandler[action.type]?.(action, this)
    },
  },
}
</script>

<style lang="scss" scoped>
  .v-list-item__subtitle ::v-deep > p {
    margin-bottom: 0;
  }
</style>
